"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStore = undefined;

var _asyncToGenerator2 = require("@babel/runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _regenerator = require("@babel/runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _webxJs = require("@didi/webx-js");

var _core = require("@mpxjs/core");

var _util = require("../lib/js/util");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

function getDataFromQuery() {
    try {
        return _getDataFromQuery.apply(this, arguments);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('getDataFromQuery@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

function _getDataFromQuery() {
    try {
        _getDataFromQuery = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            try {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    try {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                            case 0:
                                window.PerfTrack.requestBegin();
                                console.log('process.env.WEBX_ENV', process.env.WEBX_ENV);
                                return _context2.abrupt('return', (0, _webxJs.init)({
                                    initOption: {
                                        quitInitProduct: false,
                                        needPageConfig: true,
                                        needShareConfig: true,
                                        env: process.env.WEBX_ENV
                                    }
                                }).then(function func_trir_078fb39e4cb715e28c22032d3fb9294b(webxConfig) {
                                    try {
                                        window.PerfTrack.responseReady();
                                        return webxConfig;
                                    } catch (e)
                                                                                {
                                            'use strict';
                                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                                try {
                                                    JSON.stringify(k);
                                                    return true;
                                                } catch (e) {
                                                    return false;
                                                }
                                            });
                                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_078fb39e4cb715e28c22032d3fb9294b@@../../../../src/store/index.js@@-1', -1, e.message, {
                                                stack: e.stack,
                                                arguments: omegaParams
                                            }) : '';
                                            throw e;
                                        }
                                })['catch'](function func_trir_bb960c5e3163b5499a4737bd040103b8(webxPageError) {
                                    try {
                                        console.error('webx get page config error', webxPageError);
                                        (0, _util.handleToast)('网络不给力 请稍后再试');
                                    } catch (e)
                                                                                {
                                            'use strict';
                                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                                try {
                                                    JSON.stringify(k);
                                                    return true;
                                                } catch (e) {
                                                    return false;
                                                }
                                            });
                                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_bb960c5e3163b5499a4737bd040103b8@@../../../../src/store/index.js@@-1', -1, e.message, {
                                                stack: e.stack,
                                                arguments: omegaParams
                                            }) : '';
                                            throw e;
                                        }
                                }));
                            case 3:
                            case 'end':
                                return _context2.stop();
                            }
                        }
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee2$@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }, _callee2);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee2@@../../../../src/store/index.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        }));
        return _getDataFromQuery.apply(this, arguments);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_getDataFromQuery@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

var actions = {
  getPageData: function getPageData(_ref) {
    try {
        return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            try {
                var commit, res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    try {
                        while (1) {
                            switch (_context.prev = _context.next) {
                            case 0:
                                commit = _ref.commit;
                                _context.next = 3;
                                return getDataFromQuery();
                            case 3:
                                res = _context.sent;
                                commit('setPageData', res);
                                return _context.abrupt('return', res);
                            case 6:
                            case 'end':
                                return _context.stop();
                            }
                        }
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee$@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }, _callee);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee@@../../../../src/store/index.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        }))();
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('getPageData@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
  setInitData: function setInitData(_ref2, _ref3) {
    try {
        var commit = _ref2.commit;
        var payload = _ref3.payload;
        commit('setPageData', payload);
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('setInitData@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
};
var store = (0, _core.createStore)({
  state: {
    count: 0,
    page: {
      global: {},
      scenes: {
        layers: []
      }
    },
    isAutoReceive: false,
    userInfo: {},
    prefetched: false
  },
  mutations: {
    increment: function increment(state) {
    try {
        state.count++;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('increment@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    setPageData: function setPageData(state, payload) {
    try {
        state.page = payload;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('setPageData@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    setAutoReceive: function setAutoReceive(state, data) {
    try {
        state.isAutoReceive = data;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('setAutoReceive@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    setUserInfo: function setUserInfo(state, data) {
    try {
        state.userInfo = data;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('setUserInfo@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  getters: {
    isAutoReceive: function isAutoReceive(state) {
    try {
        return state.isAutoReceive;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('isAutoReceive@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
    userInfo: function userInfo(state) {
    try {
        return state.userInfo;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('userInfo@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  },
  actions: actions
});

var _store;

var getStore = function getStore(isServerEntry) {
    try {
        if (_store && !isServerEntry)
            return _store;
        _store = (0, _core.createStore)({
            state: {
                count: 0,
                loginEnd: false,
                page: {
                    global: {},
                    scenes: { layers: [] }
                },
                isAutoReceive: false,
                userInfo: {},
                prefetched: false
            },
            mutations: {
                increment: function increment(state) {
                    try {
                        state.count++;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('increment@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                },
                setPageData: function setPageData(state, payload) {
                    try {
                        state.page = payload;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('setPageData@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                },
                setAutoReceive: function setAutoReceive(state, data) {
                    try {
                        console.log('setAutoReceive__store', data);
                        state.isAutoReceive = data;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('setAutoReceive@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                },
                setUserInfo: function setUserInfo(state, data) {
                    try {
                        console.log('setUserInfo__store', data);
                        state.userInfo = data;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('setUserInfo@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                },
                setLoginEnd: function setLoginEnd(state, data) {
                    try {
                        console.log('setLoginEndData:', data);
                        state.loginEnd = data;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('setLoginEnd@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }
            },
            getters: {
                isAutoReceive: function isAutoReceive(state) {
                    try {
                        return state.isAutoReceive;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('isAutoReceive@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                },
                userInfo: function userInfo(state) {
                    try {
                        return state.userInfo;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('userInfo@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                },
                loginEnd: function loginEnd(state) {
                    try {
                        return state.loginEnd;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('loginEnd@@../../../../src/store/index.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }
            },
            actions: actions
        });
        return _store;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('getStore@@../../../../src/store/index.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};

exports.getStore = getStore;
exports.default = store;